import React from 'react';

const sizeMap = {
  small: { height: '35vh', width: 'calc(100% - 6rem)' },
  medium: { height: '25vh', width: 'calc(100% - 6rem)' },
  large: { height: '70vh', width: 'calc(100vw - 150px)' },
};

const ChartContainer = ({ size = 'medium', height, width, padding, children }) => {
  const resolvedSize = sizeMap[size] || sizeMap.medium;

  const containerHeight = height || resolvedSize.height;
  const containerWidth = width || resolvedSize.width;

  return (
    <div
      style={{
        height: containerHeight,
        width: containerWidth,
        marginBottom: 20,
        overflow: 'hidden',
        position: 'relative',
        // Moderately increase padding to add space back, still less than original
        padding: padding || '1.25rem 1.25rem 1rem',
        backgroundColor: 'white',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
      }}
    >
      {children}
    </div>
  );
};

export default ChartContainer;
